<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('careers-panel')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">News Career Content</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p class="pb-2">Role</p>
        <base-input
          alternative
          class="mb-3"
          name="Job Role"
          required
          placeholder="Job Role"
          v-model="role"
        >
        </base-input>

        <!-- <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        /> -->
        <!-- <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <img v-if="image" :src="image" ref="cover" />
        <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->

        <!-- <b-form-group id="input-group-3" label="Tags:" label-for="input-3">
          <b-form-select id="input-3" v-model="selectedtag" required>
            <b-form-select-option :value="null" disabled
              >-- Please select an Tags --</b-form-select-option
            >
            <b-form-select-option
              v-for="(tag, indexOpt) in tags"
              :value="tag._id"
              :key="indexOpt"
              >{{ tag.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group> -->

        <p class="pb-2">Location</p>
        <base-input
          alternative
          class="mb-3"
          name="Location"
          required
          placeholder="Enter Location"
          v-model="location"
        >
        </base-input>

        <p class="pb-2">Responsibilities Included</p>
        <!-- <b-form-textarea
          id="textarea-rows"
          placeholder="Write"
          rows="3"
          v-model="responsi"
          class=""
        ></b-form-textarea> -->
        <quill-editor
          v-model="responsibility"
          :options="editorOption"
          class="quill-h200px my-2"
        />
        <span v-if="respErr" class="small text-danger">{{ msg.resp }}</span>

        <p class="pb-2">Skills Required</p>
        <!-- <b-form-textarea
          id="textarea-rows"
          placeholder="Write"
          rows="3"
          v-model="skill"
          class=""
        ></b-form-textarea> -->
        <quill-editor
          v-model="skills"
          :options="editorOption"
          class="quill-h200px my-2"
        />
        <span v-if="skillErr" class="small text-danger">{{ msg.skill }}</span>

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      role: "",
      location: "",
      responsibility: "",
      skills: "",
      editorOption: {
        theme: "snow",
      },
      respErr: false,
      skillErr: false,
      msg: {},
    };
  },
  // computed: {
  //   ...mapState("cms", {
  //     listings: "listings",
  //     pageCategories: "pageCategories",
  //   }),
  //   ...mapState("cmstag", {
  //     tags: "tags",
  //   }),
  // },
  methods: {
    // handleSuccess(image) {
    //   this.coverImage = image;
    //   this.readerData(image);
    // },
    // readerData(rawFile) {
    //   let loader = this.$loading();

    //   const reader = new FileReader();
    //   reader.onload = (e) => {
    //     this.$emit("load", (this.image = e.target.result));

    //     loader.close();
    //   };
    //   reader.readAsDataURL(rawFile);
    // },
    // async onSubmit() {
    //   let FormData = require("form-data");
    //   let data = new FormData();
    //   data.append("type", "single");
    //   data.append("title", this.title);
    //   data.append("subTitle", "");
    //   data.append("media", this.coverImage);
    //   data.append("html", this.body);
    //   // data.append("tags[0]", this.selectedtag);
    //   data.append("listing", this.listings[0]._id);
    //   data.append("pageCategory", this.selectedPageCategory);

    //   let loader = this.$loading();

    //   try {
    //     await this.$store.dispatch("cms/addPage", data);
    //     this.$router.push({ name: "social-admin-blog" });
    //     loader.close();
    //   } catch (error) {
    //     if (error) {
    //       loader.close();
    //     }
    //   }
    // },
    // async init() {
    //   await this.$store.dispatch("cms/getListings");
    //   await this.$store.dispatch("cmstag/getTags");
    //   await this.$store.dispatch("cms/getPageCategories");
    // },

    handleClick(name) {
      this.$router.push({ name: name });
    },
    async onSubmit() {
      let payload = {
        jobRole: this.role,
        location: this.location,
        skills: this.skills,
        responsibility: this.responsibility,
      };
      // console.log(payload);
      let loader = this.$loading();

      try {
        if (this.responsibility == "") {
          this.respErr = true;
          this.msg.resp = "Field is required";
        } else if (this.skills == "") {
          this.skillErr = true;
          this.msg.skill = "Field is required";
        } else {
          const careerdata = await this.$store.dispatch(
            "cms/addCareer",
            payload
          );
          if (careerdata.code == 200) {
            this.$router.push({ name: "careers-panel" });
            this.$swal.fire({
              title: "Success!",
              text: "Your career details have been added",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
  },
  // mounted() {
  //   this.init();
  // },
};
</script>
